<template>
  <v-card flat>
    <block v-if="loading"></block>

    <v-card-text class="pa-3 py-0">
      <v-form class="box my-4 mx-0 pa-4" ref="apiKeyForm" v-model="valid">
        <v-row>
          <v-col cols="12" class="tabsNh">
            <v-col cols="12" md="12" class="d-flex justify-end">
              <v-btn
                small
                class="btn-save"
                :disabled="loading"
                @click.prevent="createApiKey"
              >
                <v-icon>mdi-content-save</v-icon>
              </v-btn>
            </v-col>
          </v-col>
        </v-row>

        <v-row class="mt-8">
          <v-col cols="12">
            <h3>Crear API key de facturación</h3>
          </v-col>

          <v-col cols="12" md="5">
            <div class="d-flex align-start">
              <v-autocomplete
                outlined
                dense
                attach
                v-model="form.ID_Branch"
                :items="branches"
                item-text="BranchName"
                item-value="ID_Branch"
                label="Sucursal*"
                :rules="[requiredRule]"
              ></v-autocomplete>
              <v-btn
                small
                class="btnblue ml-2"
                :disabled="loading"
                @click="showBranchDialog = true"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </div>
          </v-col>

          <v-col cols="12" md="5">
            <div class="d-flex align-start">
              <v-autocomplete
                outlined
                dense
                attach
                v-model="form.ID_User"
                :items="userOptions"
                item-text="DisplayName"
                item-value="ID_User"
                label="Usuario*"
                :rules="[requiredRule]"
              ></v-autocomplete>
              <v-btn
                small
                class="btnblue ml-2"
                :disabled="loading"
                @click="showUserDialog = true"
              >
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>

        <v-row class="mx-0">
          <v-col cols="12">
            <h3>API keys creadas</h3>
          </v-col>

          <v-col v-if="apiKeys.length === 0" cols="12">
            <v-alert dense outlined type="info">
              No hay API keys registradas.
            </v-alert>
          </v-col>

          <v-col
            v-for="item in apiKeys"
            :key="getApiKeyId(item)"
            cols="12"
            md="4"
          >
            <v-card
              outlined
              class="api-key-card"
              :class="{ 'api-key-card--inactive': !isApiKeyActive(item) }"
            >
              <v-card-title class="api-key-card__title d-flex justify-space-between align-start">
                <span>{{ formatApiKeyBranch(item) }}</span>
                <v-btn
                  small
                  class="btndelete"
                  :disabled="loading || !isApiKeyActive(item)"
                  @click="confirmDeactivate(item)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </v-card-title>

              <v-card-text>
                <div class="mb-1">
                  <strong>Usuario:</strong> {{ formatApiKeyUser(item) }}
                </div>
                <div class="mb-1">
                  <strong>ID:</strong> {{ getApiKeyId(item) }}
                </div>
                <div class="mb-2 api-key-mask">
                  <strong>API key:</strong> {{ item.view_api_key ? item.api_key : maskApiKey(item.api_key) }}&nbsp;<v-icon small @click="toggleApiKeyVisibility(item)">mdi-eye</v-icon>
                </div>
                <v-chip
                  small
                  :color="apiKeyStatusColor(item)"
                  text-color="white"
                >
                  {{ apiKeyStatusLabel(item) }}
                </v-chip>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-form>

      
    </v-card-text>

    <v-dialog v-model="showBranchDialog" scrollable width="90%">
      <v-card>
        <div class="dialog-actions">
          <v-btn small class="btndelete" @click.prevent="showBranchDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <v-text-field
            outlined
            dense
            clearable
            v-model="branchDialogFilter"
            label="Buscar sucursal"
          ></v-text-field>

          <DxDataGrid
            class="isScrolledByGeneralFilter"
            :show-borders="true"
            :data-source="filteredBranches"
            key-expr="ID_Branch"
          >
            <DxScrolling row-rendering-mode="virtual" />
            <DxPaging :page-size="10" />
            <DxColumn :width="80" cell-template="select-branch" caption=""></DxColumn>
            <DxColumn data-field="BranchName" caption="Sucursal"></DxColumn>
            <DxColumn data-field="BranchLegalName" caption="Nombre legal de la sucursal"></DxColumn>
            <template #select-branch="{ data }">
              <a href="#" @click.prevent.stop="selectBranch(data.data)">
                <v-icon color="primary">mdi-check-bold</v-icon>
              </a>
            </template>
          </DxDataGrid>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="showUserDialog" scrollable width="90%">
      <v-card>
        <div class="dialog-actions">
          <v-btn small class="btndelete" @click.prevent="showUserDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <v-text-field
            outlined
            dense
            clearable
            v-model="userDialogFilter"
            label="Buscar usuario"
          ></v-text-field>

          <DxDataGrid
            class="isScrolledByGeneralFilter"
            :show-borders="true"
            :data-source="filteredUsers"
            key-expr="ID_User"
          >
            <DxScrolling row-rendering-mode="virtual" />
            <DxPaging :page-size="10" />
            <DxColumn :width="80" cell-template="select-user" caption=""></DxColumn>
            <DxColumn data-field="ID_User" caption="ID"></DxColumn>
            <DxColumn data-field="UserName" caption="Usuario"></DxColumn>
            <DxColumn data-field="FirstName" caption="Nombres"></DxColumn>
            <DxColumn data-field="LastName" caption="Apellidos"></DxColumn>
            <DxColumn data-field="BranchName" caption="Sucursal"></DxColumn>
            <template #select-user="{ data }">
              <a href="#" @click.prevent.stop="selectUser(data.data)">
                <v-icon color="primary">mdi-check-bold</v-icon>
              </a>
            </template>
          </DxDataGrid>
        </v-card-text>
      </v-card>
    </v-dialog>

    <alerts
      v-if="alert.show"
      v-on:close_alert="closeAlert"
      v-on:accept_alert="acceptAlert"
      :properties="alert"
    ></alerts>
  </v-card>
</template>

<script>
import Alerts from "@/components/Alerts";
import Block from "@/components/Block";
import {
  DxDataGrid,
  DxColumn,
  DxScrolling,
  DxPaging,
} from "devextreme-vue/data-grid";

export default {
  name: "ManageApiKeys",
  components: {
    Alerts,
    Block,
    DxDataGrid,
    DxColumn,
    DxScrolling,
    DxPaging,
  },
  props: ["business", "win"],
  data: () => ({
    valid: false,
    loading: false,
    form: {
      ID_Branch: null,
      ID_User: null,
    },
    branches: [],
    users: [],
    apiKeys: [],
    showBranchDialog: false,
    showUserDialog: false,
    branchDialogFilter: "",
    userDialogFilter: "",
    apiKeyToDeactivate: null,
    alert: {
      type: "success",
      show: false,
      header: "",
      body: "",
      options: null,
    },
    requiredRule: (value) => !!value || "Campo requerido",
  }),
  mounted() {
    this.loadInitialData();
  },
  computed: {
    businessId() {
      const user = this.getCurrentUser();
      return this.business?.ID_Business || user?.businessid || null;
    },
    businessUserQuery() {
      const user = this.getCurrentUser();
      return (
        this.business?.BusinessName ||
        this.business?.BusinessLegalName ||
        user?.business ||
        this.businessId
      );
    },
    userOptions() {
      return this.users.map((user) => ({
        ...user,
        DisplayName: this.formatUserOption(user),
      }));
    },
    filteredBranches() {
      const filter = this.normalizeFilter(this.branchDialogFilter);

      if (!filter) {
        return this.branches;
      }

      return this.branches.filter((branch) => {
        return [
          branch.ID_Branch,
          branch.BranchName,
          branch.BranchLegalName,
        ]
          .join(" ")
          .toLowerCase()
          .includes(filter);
      });
    },
    filteredUsers() {
      const filter = this.normalizeFilter(this.userDialogFilter);

      if (!filter) {
        return this.userOptions;
      }

      return this.userOptions.filter((user) => {
        return [
          user.ID_User,
          user.UserName,
          user.FirstName,
          user.LastName,
          user.Email,
          user.BranchName,
          user.DisplayName,
        ]
          .join(" ")
          .toLowerCase()
          .includes(filter);
      });
    },
  },
  methods: {
    async loadInitialData() {
      this.loading = true;
      await Promise.all([this.getBranches(), this.getUsers(), this.getApiKeys()]);
      this.loading = false;
    },
    async getBranches() {
      if (!this.businessId) {
        return;
      }

      try {
        const data = await this.$API.branches.findBranches(this.businessId);
        this.branches = Array.isArray(data) ? data : [];
      } catch {
        this.showAlert(
          "danger",
          "Error",
          "Ha ocurrido un error en obtener las sucursales del negocio."
        );
      }
    },
    async getUsers() {
      if (!this.businessUserQuery) {
        return;
      }

      try {
        const data = await this.$API.users.getUsers(this.businessUserQuery);
        this.users = Array.isArray(data) ? data : [];
      } catch {
        this.showAlert(
          "danger",
          "Error",
          "Ha ocurrido un error en obtener los usuarios del negocio."
        );
      }
    },
    async getApiKeys() {
      if (!this.businessId) {
        return;
      }

      try {
        const response = await this.$API.apiKey.getApiKeys();
        this.apiKeys = this.normalizeApiKeysResponse(response);
      } catch {
        this.showAlert(
          "danger",
          "Error",
          "Ha ocurrido un error en obtener las API keys del negocio."
        );
      }
    },
    async createApiKey() {
      if (
        !this.$refs.apiKeyForm.validate() ||
        !this.form.ID_Branch ||
        !this.form.ID_User
      ) {
        this.showAlert(
          "warning",
          "Advertencia",
          "Debe seleccionar una sucursal y un usuario."
        );
        return;
      }

      this.loading = true;

      try {
        await this.$API.apiKey.createApiKey( this.form.ID_Branch, this.form.ID_User );

        this.form.ID_Branch = null;
        this.form.ID_User = null;
        this.$refs.apiKeyForm.resetValidation();
        await this.getApiKeys();
        this.showAlert("success", "Exito", "API key creada correctamente.");
      } catch (error) {
        console.log(error);
        this.showAlert(
          "danger",
          "Error",
          "Ha ocurrido un error en crear la API key."
        );
      } finally {
        this.loading = false;
      }
    },
    confirmDeactivate(item) {
      this.apiKeyToDeactivate = item;
      this.showAlert(
        "question",
        "Advertencia",
        "¿Está seguro de desactivar la API key seleccionada?",
        "deactivateApiKey"
      );
    },
    async deactivateSelectedApiKey() {
      const idApiKey = this.getApiKeyId(this.apiKeyToDeactivate);

      if (!idApiKey) {
        this.apiKeyToDeactivate = null;
        return;
      }

      this.loading = true;

      try {
        await this.$API.apiKey.deactivateApiKey(idApiKey);
        await this.getApiKeys();
        this.showAlert("success", "Exito", "API key desactivada correctamente.");
      } catch {
        this.showAlert(
          "danger",
          "Error",
          "Ha ocurrido un error en desactivar la API key."
        );
      } finally {
        this.loading = false;
        this.apiKeyToDeactivate = null;
      }
    },
    selectBranch(branch) {
      this.form.ID_Branch = branch.ID_Branch;
      this.showBranchDialog = false;
    },
    selectUser(user) {
      this.form.ID_User = user.ID_User;
      this.showUserDialog = false;
    },
    closeAlert() {
      if (this.alert.options === "deactivateApiKey") {
        this.apiKeyToDeactivate = null;
      }

      this.alert.show = false;
      this.alert.options = null;
    },
    async acceptAlert() {
      const option = this.alert.options;
      this.alert.show = false;
      this.alert.options = null;

      if (option === "deactivateApiKey") {
        await this.deactivateSelectedApiKey();
      }
    },
    showAlert(type, header, body, options = null) {
      this.alert.type = type == null ? "danger" : type;
      this.alert.header = header;
      this.alert.body = body;
      this.alert.show = true;
      this.alert.options = options;
    },
    normalizeApiKeysResponse(response) {
      if (Array.isArray(response)) {
        return response;
      }

      if (response && Array.isArray(response.data)) {
        return response.data;
      }

      return [];
    },
    getCurrentUser() {
      try {
        return JSON.parse(localStorage.getItem("user"));
      } catch {
        return {};
      }
    },
    getApiKeyId(item = {}) {
      return item.id_api_key || item.ID_Api_Key || item.ID_API_Key || null;
    },
    isApiKeyActive(item = {}) {
      return Number(item.api_key_status) !== 0;
    },
    apiKeyStatusColor(item) {
      return this.isApiKeyActive(item) ? "success" : "error";
    },
    apiKeyStatusLabel(item) {
      return this.isApiKeyActive(item) ? "Activa" : "Inactiva";
    },
    formatApiKeyBranch(item = {}) {
      return (
        item.branch_name ||
        item.BranchName ||
        this.findBranchName(item.ID_Branch) ||
        "Sucursal no disponible"
      );
    },
    formatApiKeyUser(item = {}) {
      return item.user_name || item.UserName || item.ID_User || "Usuario no disponible";
    },
    findBranchName(idBranch) {
      const branch = this.branches.find(
        (item) => Number(item.ID_Branch) === Number(idBranch)
      );

      return branch?.BranchName || branch?.BranchLegalName || "";
    },
    formatUserOption(user = {}) {
      const fullName = `${user.FirstName || ""} ${user.LastName || ""}`.trim();

      if (fullName && user.UserName) {
        return `${fullName} (${user.UserName})`;
      }

      return fullName || user.UserName || user.ID_User;
    },
    maskApiKey(apiKey) {
      if (!apiKey) {
        return "No disponible";
      }

      const value = apiKey.toString();
      const suffix = value.slice(-4);
      return `********${suffix}`;
    },
    normalizeFilter(value) {
      return value ? value.toString().trim().toLowerCase() : "";
    },
    toggleApiKeyVisibility(item) {
      item.view_api_key = !item.view_api_key;
    }
  },
};
</script>

<style scoped>
.btnsave {
  background-color: #00a178 !important;
  color: white;
}

.btnblue {
  background-color: #1976d2 !important;
  color: white;
}

.btndelete {
  background-color: #e3191e !important;
  color: white;
}

.tabsNh {
  width: 100%;
  padding: 10px;
  background-color: rgba(60, 60, 60, 1);
  color: white !important;
  border-style: solid;
  border-color: black;
  border-width: 1px;
  border-radius: 10px;
}

.box {
  border-style: solid;
  border-color: black;
  border-width: 1px;
  background-color: white;
  border-radius: 15px;
}

.api-key-card {
  min-height: 180px;
  border-left: 4px solid #1976d2 !important;
}

.api-key-card--inactive {
  opacity: 0.75;
  border-left-color: #e3191e !important;
}

.api-key-card__title {
  font-size: 16px;
  line-height: 1.3;
  word-break: break-word;
}

.api-key-mask {
  font-family: "Courier New", Courier, monospace;
}

.dialog-actions {
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
  margin-right: 0.3rem;
  display: flex;
  justify-content: flex-end;
}
</style>
